import React from "react";

import WrikeTrends from "../features/wrike/WrikeTrends";

function WrikePage() {
  return <WrikeTrends />;
}

export default WrikePage;
